var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTreehouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 33,
  fill: "none",
  viewBox: "0 0 33 33"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#222830",
  strokeLinecap: "round",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  strokeWidth: 2.063,
  d: "M31.419 5.226H15.332V18.15h16.087zM31.419 1.513H15.332V4.95h16.087z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  strokeWidth: 2.063,
  d: "M20.419 18.15v-5.775c0-1.65 1.375-2.888 2.887-2.888 1.65 0 2.888 1.375 2.888 2.888v5.912H20.28z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  strokeWidth: 2.063,
  d: "M20.42 18.15v13.338M26.194 18.15v13.338M20.42 22.688h5.637M10.931 21.175l4.675-3.162M10.519 16.225l-4.675-3.163M20.42 28.05h5.637"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  strokeWidth: 2.063,
  d: "M10.794 31.488v-21.45"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  strokeWidth: 1.925,
  d: "M20.007 18.563c-1.926 4.4-4.95 5.775-9.35 5.775s-9.075-4.675-9.075-10.45S5.569 3.575 10.519 3.575s2.613.275 3.713.825"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h33v33H0z"
})))));
export default SvgTreehouse;